export default __webpack_public_path__ + "static/media/Inter-Medium.1b4ca4d0.woff2";